
































































  import Vue from 'vue'
  import GlobalNav from '@/common/components/globalHeader/Globalnav.vue'
  import { ProductCategory } from '@/model/productCategory'
  import { Badge } from '@raksul/raksul-common-ui'

  export default Vue.extend({
  components:{
    GlobalNav,
    Badge
  },
  props:{
    productCategories: {
      type: Array as () => Array<ProductCategory>,
      required: true
    },
    orderHistoryCount:{
      type: Number,
      default: 0
    }
  },
  data(): {
    showMenuProCategory: boolean,
    navLinkList: {
      title: string,
      href: string,
      badge?: number,
      target?: string
    }[]
  }{
    return {
      showMenuProCategory: false,
      navLinkList: [
        {
          title: 'ノベルティマガジン',
          href: '/cms/magazine/',
          target: '_blank'
        },
        {
          title: '再注文・増刷',
          href: '/orders',
          badge: this.orderHistoryCount
        }
      ]
    }
  },
  computed: {
    currentURL(): string {
      return window.location.pathname
    },
    isTopPage(): boolean {
      return  this.currentURL == '/'
    },
    isCatPage(): boolean {
      return this.currentURL.startsWith('/categories')
    }
  },
  methods: {
    isCurrentPage(link: string): boolean {
      return this.currentURL == link
    }
  }
})
